import { useState } from 'react';
import TextField from '@mui/material/TextField';
import { AiFillEye, AiOutlineEyeInvisible } from 'react-icons/ai';

type Props = {
    label: string;
    variant?: 'outlined' | 'standard' | 'filled';
    size?: 'small' | 'medium';
    className?: string;
    name: string;
    required?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    autoComplete?: string;
    error?: boolean;
    helperText?: string;
};

export default function InputPassword({
    label,
    variant = 'outlined',
    size = 'small',
    className = '',
    name,
    required = false,
    onChange,
    autoComplete,
    error,
    helperText,
}: Props) {
    const [hidden, setHidden] = useState(true);

    return (
        <TextField
            autoComplete={autoComplete}
            error={error}
            helperText={helperText}
            label={label}
            variant={variant}
            required={required}
            onChange={onChange}
            type={hidden ? 'password' : 'text'}
            size={size}
            name={name}
            className={className}
            InputProps={{
                endAdornment: (
                    <div
                        onClick={() => setHidden(prev => !prev)}
                        style={{
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            paddingRight: 9,
                        }}
                    >
                        {hidden ? <AiFillEye size={20} /> : <AiOutlineEyeInvisible size={20} />}
                    </div>
                ),
            }}
        />
    );
}
